// Translation: External > Provider button (Ukrainian)
export default Object.freeze({
	continueWithProvider: '',
	signUpWithProvider: '',
	signInWithProvider: ''
})
